import { subtitleLandingLight } from "assets/jss/material-kit-pro-react";
import { subtitleLandingMedium } from "assets/jss/material-kit-pro-react";
import { subtitleLanding } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  container: {
      textAlign: "center",
      padding: theme.spacing(4),
      backgroundColor: "#fff",
    },
    image: {
      width: "100%",
      height: "auto",
      borderRadius: 10,
      marginBottom: theme.spacing(2),
    },
    mainTitle: {
      ...subtitleLanding,
      fontSize: "30px",
      fontWeight: "bold",
      marginBottom: theme.spacing(2),
    },
    subtitle: {
      ...subtitleLandingMedium,
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: theme.spacing(1),
    },
    bodyText: {
      ...subtitleLandingLight,
      fontSize: "14px",
    },
});

export default style;